/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { Worker } from '../generated/graphql';
import AppUtil from './AppUtil';

export const STORAGE_KEY = 'SELECTED_DEPARTMENT_ID';

let inMemoryDept: string | null = null;

// TODO: remove this and refs to this code once URL scheme goes in
export const setSelectedDepartmentId = (id: string) => {
  // AppUtil.setInLocalStorage(STORAGE_KEY, id);
  inMemoryDept = id;
};

export const getSelectedDepartmentId = (): string | null => {
  const localValue = AppUtil.getFromLocalStorage(STORAGE_KEY);
  return inMemoryDept || localValue || null;
};

export const removeSelectedDepartmentId = () => {
  AppUtil.removeFromLocalStorage(STORAGE_KEY);
  inMemoryDept = null;
};

// TODO: Remove 2 months post release
export const isCommandModelWorker = (worker: Worker): boolean => {
  if (!worker?.features) {
    return false;
  }
  return !worker.features.includes('document_model');
};
